module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-870.9ef11004.jpg";